import {
  SYNC_DEVICES_FAILURE,
  SYNC_DEVICES_REQUEST,
  SYNC_DEVICES_SUCCESS,
  SYNC_DORMAKABA_FAILURE,
  SYNC_DORMAKABA_REQUEST,
  SYNC_DORMAKABA_SUCCESS,
  SYNC_PERSONS_FAILURE,
  SYNC_PERSONS_REQUEST,
  SYNC_PERSONS_SUCCESS,
  SYNC_PERSON_FAILURE,
  SYNC_PERSON_REQUEST,
  SYNC_PERSON_SUCCESS,
} from '../../../actionConstants';

import { deleteUnderscore } from '../../../utils';

import apiClient from '../../../apiClient';

const normalizeProviderType = (accountType) => {
  const type = deleteUnderscore(accountType);
  if (type === 'twon') return '2n';
  if (type === 'dormakaba') return 'dormakaba';
  return type;
};

const syncDevices = (dispatch, buildingId, type) =>
  dispatch({
    type: SYNC_DEVICES_REQUEST,
    payload: apiClient.sync.devices(buildingId, type).then(
      (res) =>
        dispatch({
          type: SYNC_DEVICES_SUCCESS,
          successMessage: 'Devices synced successfully',
          res,
        }),
      (err) =>
        dispatch({
          type: SYNC_DEVICES_FAILURE,
          err,
        }),
    ),
  });

export const syncPersons = (dispatch, buildingId, type) =>
  dispatch({
    type: SYNC_PERSONS_REQUEST,
    payload: apiClient.sync.persons(buildingId, type).then(
      (res) =>
        dispatch({
          type: SYNC_PERSONS_SUCCESS,
          successMessage: 'Persons synced successfully',
          res,
        }),
      (err) =>
        dispatch({
          type: SYNC_PERSONS_FAILURE,
          err,
        }),
    ),
  });

export const sync = (dispatch, actionType, accountType, buildingId) => {
  const type = normalizeProviderType(accountType);
  if (actionType === 'syncDevices')
    return syncDevices(dispatch, buildingId, type);
  if (actionType === 'syncPersons')
    return syncPersons(dispatch, buildingId, type);
  return null;
};

export const syncPerson = (dispatch, buildingId, personId, type) =>
  dispatch({
    type: SYNC_PERSON_REQUEST,
    payload: apiClient.sync.person(buildingId, personId, type).then(
      (res) =>
        dispatch({
          type: SYNC_PERSON_SUCCESS,
          successMessage: 'Person synced successfully',
          res,
        }),
      (err) =>
        dispatch({
          type: SYNC_PERSON_FAILURE,
          err,
        }),
    ),
  });

export const syncDormakaba = (dispatch, buildingId, file) => {
  const formData = new FormData();
  formData.append(file.name, file);

  return dispatch({
    type: SYNC_DORMAKABA_REQUEST,
    payload: apiClient.sync.dormakaba(buildingId, formData).then(
      (res) =>
        dispatch({
          type: SYNC_DORMAKABA_SUCCESS,
          successMessage: 'Synced successfully',
          res,
        }),
      (err) =>
        dispatch({
          type: SYNC_DORMAKABA_FAILURE,
          err,
        }),
    ),
  });
};
